import EditableFieldDef from "./EditableFieldDef";

const projectFieldDefs = [
  new EditableFieldDef({
    fieldName: "newProjectType",
    label: "Project Type",
    required: false,
    type: "select",
    options: [
      { key: "New Condo", value: "New Condo" },
      { key: "Established Condo", value: "Established Condo" }
    ],
  }), new EditableFieldDef({
    fieldName: "projectName",
    label: "Project Legal Name",
    required: true,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "altProjectName",
    label: "Alternate Project Name",
    required: false,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "masterAssociationName",
    label: "Master Association Name",
    required: false,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "street",
    label: "Street Address",
    required: true,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "city",
    label: "City",
    required: true,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "state",
    label: "State",
    required: true,
    type: "select",
    options: [{ key: "", value: "Select State" }]
  }), new EditableFieldDef({
    fieldName: "zip5",
    label: "Zip",
    required: true,
    type: "text",
    validatePartial: value => /^[0-9]{0,5}$/.test(value),
    validateComplete: value => /^[0-9]{5}$/.test(value),
    invalidMessage: "Please enter a valid 5-digit ZIP code."
  }), new EditableFieldDef({
    fieldName: "unitCount",
    label: "Total Units",
    required: true,
    type: "number",
    validatePartial: value => /^[1-9]?[0-9]*$/.test(value),
    validateComplete: value => /^[1-9][0-9]*$/.test(value),
    invalidMessage: "Please enter a valid number greater than 0."
  }), new EditableFieldDef({
    fieldName: "projectStyle",
    label: "Project Style",
    required: false,
    type: "select",
    options: [{ key: "", value: "Select Style" }]
  }), new EditableFieldDef({
    fieldName: "styleComments",
    label: "Style Comments",
    // NOTE: only actually required when projectStyle === "Other" (see Project.js);
    // ProjectInfoEditorAccordion applies that conditional itself since this shared
    // field def has no per-DAO context here.
    required: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "hoaName",
    label: "HOA Name",
    required: false,
    type: "text"
  }), new EditableFieldDef({
    fieldName: "hoaTaxId",
    label: "HOA Tax ID",
    required: false,
    type: "text",
    validatePartial: value => /^[0-9]{0,2}-?[0-9]{0,7}$/.test(value),
    validateComplete: value => /^[0-9]{2}-?[0-9]{7}$/.test(value),
    invalidMessage: "Please enter a valid Tax ID (EIN) in the format XX-XXXXXXX."
  }), new EditableFieldDef({
    fieldName: "coopInd",
    label: "Is the project a cooperative?",
    required: true,
    type: "select",
    options: [
      { key: "true", value: "Yes" },
      { key: "false", value: "No" }
    ],
    formatValue: value => value === true ? "Yes"
      : value === false ? "No"
      : value ?? ""
  }), new EditableFieldDef({
    fieldName: "manfdHousngInd",
    label: "Does the project consist of manufactured housing?",
    required: true,
    type: "select",
    options: [
      { key: "true", value: "Yes" },
      { key: "false", value: "No" }
    ],
    formatValue: value => value === true ? "Yes"
      : value === false ? "No"
      : value ?? ""
  }), new EditableFieldDef({
    fieldName: "unitsType",
    label: "Does the project consist of attached units?",
    required: true,
    type: "select",
    options: [
      { key: "Attached", value: "Attached" },
      { key: "Detached", value: "Detached" },
      { key: "Combination", value: "Combination" }
    ]
  })];

  export default projectFieldDefs;